module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/cd-d44809aaad5d32f91a56124d5f222aba.svg";